import { render, staticRenderFns } from "./AlertPage.vue?vue&type=template&id=77afcb1a&scoped=true&"
import script from "./AlertPage.vue?vue&type=script&lang=js&"
export * from "./AlertPage.vue?vue&type=script&lang=js&"
import style0 from "./../../../../assets/mobileStyle.css?vue&type=style&index=0&id=77afcb1a&prod&scoped=true&lang=css&"
import style1 from "./AlertPage.vue?vue&type=style&index=1&id=77afcb1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afcb1a",
  null
  
)

export default component.exports